/**
 * 渠道热点路由模块
 */
"use strict";
angular.module("channelHotSpotsRouterModule", []).
config(["$stateProvider", function($stateProvider) {
    $stateProvider.
    state("front.plan.hotfocus.channelHotSpots.newspaperhotspots", {
        url: "/newspaperhotspots",
        views: {
            "main@front.plan.hotfocus.channelHotSpots": {
                templateUrl: "./planningCenter/hotFocus/channelHotSpots/newsPaperHotSpots/newsPaperHotSpots_tpl.html",
                controller: "newsPaperChannelHotSpotsCtrl"
            }
        }
    }).
    state("front.plan.hotfocus.channelHotSpots.websitehotspots", {
        url: "/websitehotspots",
        views: {
            "main@front.plan.hotfocus.channelHotSpots": {
                templateUrl: "./planningCenter/hotFocus/channelHotSpots/websiteHotSpots/websiteHotSpots_tpl.html",
                controller: "websiteChannelHotSpotsCtrl"
            }
        }
    }).
    state("front.plan.hotfocus.channelHotSpots.apphotspots", {
        url: "/apphotspots",
        views: {
            "main@front.plan.hotfocus.channelHotSpots": {
                templateUrl: "./planningCenter/hotFocus/channelHotSpots/appHotSpots/appHotSpots_tpl.html",
                controller: "appChannelHotSpotsCtrl"
            }
        }
    }).
    state("front.plan.hotfocus.channelHotSpots.weixinhotspots", {
        url: "/weixinhotspots",
        views: {
            "main@front.plan.hotfocus.channelHotSpots": {
                templateUrl: "./planningCenter/hotFocus/channelHotSpots/weixinHotSpots/weixinHotSpots_tpl.html",
                controller: "weixinChannelHotSpotsCtrl"
            }
        }
    }).
    state("front.plan.hotfocus.channelHotSpots.weibohotspots", {
        url: "/weibohotspots",
        views: {
            "main@front.plan.hotfocus.channelHotSpots": {
                templateUrl: "./planningCenter/hotFocus/channelHotSpots/weiboHotSpots/weiboHotSpots_tpl.html",
                controller: "weiboChannelHotSpotsCtrl"
            }
        }
    }).//微博两级列表页
    state("front.plan.hotfocus.channelHotSpots.weibohotspots.channelweibosecond", {
        url: "/channelweibosecond?batchid&eventid",
        views: {
            "main@front.plan.hotfocus.channelHotSpots": {
                templateUrl: "./planningCenter/hotFocus/channelHotSpots/weiboHotSpots/weiboSecondList/weiboSecondList_tpl.html",
                controller: "weiboSecondChannelHotSpotsCtrl"
            }
        }
    }).
    state("front.plan.hotfocus.channelHotSpots.searchhotspots", {
        url: "/searchhotspots",
        views: {
            "main@front.plan.hotfocus.channelHotSpots": {
                templateUrl: "./planningCenter/hotFocus/channelHotSpots/searchHotSpots/searchHotSpots_tpl.html",
                controller: "searchChannelHotSpotsCtrl"
            }
        }
    })
}]);